import React from 'react';


const Sablier = () => {

    return (
        <div>
            <h1>Coming soon</h1>
        </div>
    );
}

export default Sablier;
